import { render, staticRenderFns } from "./Shedule.vue?vue&type=template&id=f60a4ede"
import script from "./Shedule.vue?vue&type=script&lang=js"
export * from "./Shedule.vue?vue&type=script&lang=js"
import style0 from "./Shedule.vue?vue&type=style&index=0&id=f60a4ede&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports